<template>
  <page-frame :header="path">
    <el-skeleton :loading="loading" animated style="margin: 20px 40px">
      <template slot="template">
        <div class="title-md">
          <el-skeleton-item variant="text" style="width: 10%" />
        </div>
        <artical-card
          v-for="(_, i) in Array(5)"
          :key="i - 5"
          :info="{}"
          :loading="true"
          style="margin-bottom: 20px"
        />
      </template>
      <template>
        <div
          v-for="projectsList in projectsByYears"
          :key="projectsList[0].time.getYear()"
          style="margin-bottom: 40px"
        >
          <div class="title-md" :id="projectsList[0].time.getFullYear()">
            {{ projectsList[0].time.getFullYear() }}
          </div>
          <artical-card
            v-for="info in projectsList"
            :info="info"
            :key="info.id"
            :loading="false"
            style="margin-bottom: 20px"
          />
        </div>
      </template>
    </el-skeleton>
    <el-button
      v-if="$store.state.token"
      type="primary"
      icon="el-icon-edit"
      circle
      @click="newArtical"
      style="
        position: fixed;
        right: 100px;
        bottom: 100px;
        width: 60px;
        height: 60px;
      "
    />
  </page-frame>
</template>
<script>
import ArticalCard from "../components/ArticalCard.vue";
import PageFrame from "../components/PageFrame.vue";

export default {
  name: "ProjectsPage",
  components: { ArticalCard, PageFrame },
  created() {
    this.$axios.get("/projects/").then((res) => {
      this.loading = false;
      const projectsList = res.data.data.records
        .map((x) => {
          return {
            ...x,
            time: new Date(x.created),
            type: "project",
          };
        })
        .sort((a, b) => (a.time < b.time ? 1 : -1));

      if (projectsList.length > 0) this.projectsByYears.push([projectsList[0]]);
      for (let i = 1; i < projectsList.length; i++) {
        if (projectsList[i - 1].time.getYear() == projectsList[i].time.getYear()) {
          this.projectsByYears[this.projectsByYears.length - 1].push(projectsList[i]);
        } else {
          this.projectsByYears.push([projectsList[i]]);
        }
      }
    });
  },
  data() {
    return {
      path: [
        { path: "", breadcrumbName: this.$t("navigation.home") },
        { path: "projects", breadcrumbName: this.$t("navigation.projects") },
      ],
      loading: true,
      projectsByYears: [],
      newArtical: () => {
        this.$router.push("projectdetail");
      },
    };
  },
};
</script>